/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const breadcrumbs = () => {
  const breadcrumbsList = document.querySelector('.c-breadcrumbs');

  if (typeof breadcrumbsList !== 'undefined' && breadcrumbsList != null) {
    breadcrumbsList
      .querySelector('.breadcrumb_last')
      .parentElement.classList.add('breadcrumb_last-link');
  }
};

export default breadcrumbs;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/breadcrumbs.js